import { BaseServices } from './../../kuba.services';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { HelpSupport } from '../models/helpsupport';
import { HelpSupportServices } from '../services/help-support.service';

@Injectable()
export class HelpSupportListResolver {
  constructor(private backend: HelpSupportServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<HelpSupport[]> {
    if (BaseServices.roleId === '1') {
      return this.backend.adminHelpSupportlist();
    } else {
      return null;
    }
  }
}

@Injectable()
export class HelpsupportEditResolver {
  constructor(private backend: HelpSupportServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.get(+route.params['aid']);
  }
}
@Injectable()
export class HelpSupportUserListResolver {
  constructor(private backend: HelpSupportServices) {}
  resolve(): Observable<HelpSupport[]> {
    return this.backend.getAllHelpSupportDetails();
  }
}
